var __default__ = {root:'m_8bffd616'};
export default __default__;